import {HttpContextToken, HttpEvent, HttpHandlerFn, HttpRequest} from '@angular/common/http';
import {inject} from "@angular/core";
import {TokenService} from '../services/token.service';
import {Observable} from 'rxjs';

export const BYPASS_AUTH_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  if (req.context.get(BYPASS_AUTH_INTERCEPTOR)) {
    return next(req);
  }

  const tokenService = inject(TokenService);
  const token = tokenService.getToken();
  
  // Only add Authorization header if a token exists
  if (token && token.trim() !== '') {
    const modifiedReq = req.clone({
      headers: req.headers.set('Authorization', 'Bearer ' + token)
    });
    return next(modifiedReq);
  }
  
  // No token, proceed without Authorization header
  return next(req);
};
